<template>
  <div id="pageSearch">
    <bread :content="breadContent"></bread>
    <p class="Page-title">搜索</p>
    <el-divider></el-divider>
    <div class="body">
      <div class="side-bar">
        <p class="item" :class="{'item--active': sortWayIndex === 0}" @click="changeSort(0)">默认排序</p>
        <p class="item" :class="{'item--active': sortWayIndex === 1}" @click="changeSort(1)">时间排序</p>
      </div>  
      <div class="content">
        <div class="search-bar">
          <input type="text" v-model="searchWord">
          <button class="btn" @click="doSearch">搜索</button>
        </div>
        <div class="result">
          <div class="block" v-for="(item, index) in result" :key="index">
            <p class="title" @click="clickResult(item)">{{ item.title || '【无标题】' }}</p>
            <div class="preview">
              <div class="image" v-if="item.imgSrc">
                <img :src="item.imgSrc" alt="预览图">
              </div>
              <div class="text">
                <div class="brief">{{ item.brief || '【暂无预览内容】' }}</div>
                <div class="info">
                  <span class="type">{{ typeNameCN[item.type] }}</span>
                  -
                  <span class="date">{{ item.date }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="block">
            <p class="title">我是练习时间好久的练习生</p>
            <div class="preview">
              <div class="image">
                <img src="" alt="预览图">
              </div>
              <div class="text">
                <div class="brief">我是练习时间好久的练习生我是练习时间好久的练习生我是练习时间好久的练习生我是练习时间我是练习时间好久的练习生我是练习时间好久的练习生我是练习时间好久的练习生</div>
                <div class="info">
                  <span class="type">人人人</span>
                  -
                  <span class="date">2019.8.5</span>
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <p class="title">我是练习时间好久的练习生</p>
            <div class="preview">
              <div class="image">
                <img src="" alt="预览图">
              </div>
              <div class="text">
                <div class="brief">我是练习时间好久的练习生我是练习时间好久的练习生我是练习时间好久的练习生我是练习时间我是练习时间好久的练习生我是练习时间好久的练习生我是练习时间好久的练习生</div>
                <div class="info">
                  <span class="type">人人人</span>
                  -
                  <span class="date">2019.8.5</span>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>   
  </div>
</template>

<script>
import bread from '@/components/bread'

export default {
  name: 'search',
  components: {
    bread
  },
  data() {
    return {
      searchWord: this.$route.query.word,
      sortWayIndex: 0, // 0:相关度排序,1:时间排序
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "搜索", routerName: "search" }
      ],
      result: [],
      typeNameCN: {
        article: '文章页',
        case: '案例库',
        'summary_of_views': '观点摘要'
      }
    }
  },
  methods: {
    async doSearch() {
      const res = await this.$net.index.search(this.searchWord, this.sortWayIndex ? 'OrderByTime' : 'Default')
      let data = []
      res.forEach(item => {
        data.push({
          id: item.Id,
          title: item.Title,
          brief: item.Brief,
          imgSrc: item.Head,
          date: item.Date,
          type: item.Type,
          L1: item.L1,
          L2: item.L2,
          L3: item.L3
        })
      })
      this.result = data
    },
    changeSort(index) {
      this.sortWayIndex = index
      this.doSearch()
    },
    clickResult(item) {
      if (item.type === 'article') {
        this.$router.push(this.$utils.mapUrl(item))
      } else if (item.type === 'summary_of_views') {
        this.$router.push('/academic/opinion/opnDetail?id=' + encodeURIComponent(item.id))
      } else if (item.type === 'case') {
        this.$router.push('/dataAndCases/cases/detail?id=' + encodeURIComponent(item.id))
      } else {
        alert('搜索结果项目异常，请联系管理人员')
      }
    }
  },
  async created() {
    this.doSearch()
  }
}
</script>

<style lang="scss" scoped>
#pageSearch {
  width: 70%;
  margin-left: 15%;
  margin-top: 80px;
  margin-bottom: 200px;
}

.body {
  display: flex;
  margin-top: 30px;
  .side-bar {
    width: 300px;
    padding-left: 30px;
    border-right: 2px solid #d7d7d7;
    .item {
      font-size: 18px;
      line-height: 40px;
      cursor: pointer;
    }
    .item--active {
      position: relative;
      font-size: 20px;
      color: $standard-blue;
      &::before {
        content: '';
        position: absolute;
        left: -25px;
        top: 8px;
        width: 5px;
        height: 24px;
        background: $standard-blue;
      }
    }
  }
  .content {
    width: 100%;
    padding-left: 40px;
    .search-bar {
      display: flex;
      width: 100%;
      height: 48px;
      margin-bottom: 50px;
      border: 1px solid #aaa;
      border-radius: 3px;
      input {
        box-sizing: border-box;
        height: 100%;
        width: calc(100% - 168px);
        padding: 0 20px;
        line-height: 48px;
        font-size: 20px;
        border: none;
        border-radius: 3px;
      }
      button {
        height: 100%;
        width: 168px;
        font-size: 24px;
        border: none;
        color: #fff;
        background-color: #339fdc;
        cursor: pointer;
      }
    }
    .result {
      width: 80%;
    }
  }
  .block {
    margin: 40px 0;
    .title {
      font-size: 20px;
      color: $standard-blue;
      margin-bottom: 15px;
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        color: #0456d2;
      }
    }
    .preview {
      display: flex;
      .image {
        max-width: 180px;
        max-height: 136px;
        margin-right: 25px;
        overflow: hidden;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .text {
        .brief {
          color: #000;
          margin-bottom: 10px;
        }
        .info {
          color: #008000;
        }
      }
    }
  }
}

</style>